import { facultiesApi } from "../../services/nomenclatures/facultiesApi";
import { Skeleton } from "primereact/skeleton";
import Error from "../common/Error";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/redux";
import FilterCard from "./FilterCard";
import { FacultyResponse } from "../../models/dtos";
import { RootState } from "../../store";
import FilterBox from "./FilterBox";

type FacultyFilterProps = {
  getSelectedFaculties: (state: RootState) => FacultyResponse[];
  setSelectedFaculties: any;
};

const FacultyFilter = ({ getSelectedFaculties, setSelectedFaculties }: FacultyFilterProps) => {
  const selectedFaculties = useSelector(getSelectedFaculties);
  const dispatch = useAppDispatch();

  const { data: faculties, error, isLoading } = facultiesApi.useGetFacultiesQuery();

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Error error={error} />;

  return (
    <FilterCard title="По факултет:">
      <FilterBox<FacultyResponse>
        filter
        value={selectedFaculties}
        onChange={(e) => dispatch(setSelectedFaculties(e.value))}
        options={faculties?.data ?? []}
        optionLabel="name"
        listClassName="max-h-20rem"
        dataKey="facultyId"
      />
    </FilterCard>
  );
};

export default FacultyFilter;
